import { z } from 'zod';

export const ITEM_TREE_SET_PERMISSION = {
  NONE: 'NONE',
  VIEW: 'VIEW',
  EDIT: 'EDIT',
} as const;

export const itemTreeSetPermissionSchema = z.enum(ITEM_TREE_SET_PERMISSION);

export const itemTreeSetEntrySchema = z.object({
  itemId: z.number().int().positive(),
  parentId: z.number().int().positive().optional(),
  permission: itemTreeSetPermissionSchema,
  matched: z.boolean(),
});

export type ItemTreeSetPermissionDTO = z.infer<typeof itemTreeSetPermissionSchema>;
export type ItemTreeSetEntryDTO = z.infer<typeof itemTreeSetEntrySchema>;
